enum BackgroundTaskStatus {
  PENDING,
  RUNNING,
  COMPLETED,
  FAILED,
}

export default BackgroundTaskStatus;
